/* ============================================================
   Stelvio Returns Portal - DIZIONARI IT/EN/DE.
   Separati dalla logica per tenere i file di dimensione
   gestibile. Espone window.scReturnsSTR.

   ACCENTI E UMLAUT: si scrivono normali (è, à, ö, ü, ß). Il file
   viaggia in UTF-8 e vengono resi correttamente; l'unica regola
   e' NIENTE BACKSLASH (upload via GraphQL block string, che non
   processa gli escape). Per l'apostrofo dentro una stringa si usa
   quello tipografico (’), non quello dritto: cosi' non serve
   nessun escape.

   TEMPI DELL'ETICHETTA (2026-07-29): la promessa "entro 24 ore
   lavorative" sta dentro ship_free e ship_swiss, NON in una
   stringa a parte. Motivo: sono le due politiche in cui
   l'etichetta la mandiamo NOI. ship_paid (resto del mondo) resta
   senza, perche' li' la spedizione la organizza il cliente e
   promettergli un'etichetta sarebbe falso. La condizione e' gia'
   nel dato: non serve scriverla nel codice.
   ============================================================ */
(function () {
  window.scReturnsSTR = {
    it: {
      title: 'Resi e cambi',
      intro: 'Inserisci il numero del tuo ordine e la email usata per l’acquisto.',
      order_ph: 'Numero ordine (es. 5126)',
      email_ph: 'La tua email',
      find: 'Trova il tuo ordine',
      not_found: 'Non troviamo un ordine con questi dati. Controlla numero e email.',
      not_shipped: 'Questo ordine non risulta ancora spedito: potrai richiederne il reso dopo la consegna.',
      order_cancelled: 'Questo ordine risulta annullato.',
      window_expired: 'Sono passati più di 14 giorni dalla consegna, quindi non possiamo gestire la richiesta dal portale. Scrivi a sales@stelviocollection.com indicando il numero d’ordine: valutiamo insieme cosa possiamo fare.',
      returns_disabled: 'Il portale resi è momentaneamente non disponibile. Riprova più tardi.',
      generic_error: 'Si è verificato un errore. Riprova tra poco.',
      rate_limited: 'Troppe richieste ravvicinate. Riprova tra qualche minuto.',
      case_open: 'Esiste già una richiesta aperta per questo ordine',
      case_open_2: 'Riceverai aggiornamenti via email. Per domande scrivi a sales@stelviocollection.com.',
      step2_title: 'Ordine',
      step2_intro: 'Scegli cosa vuoi fare per ogni articolo.',
      deadline_note: 'Puoi richiedere il reso entro il',
      estimate_note: '(data di consegna stimata)',
      order_of: 'Ordine del',
      ship_to: 'Spedito a',
      login_q: 'Vuoi rivedere i tuoi ordini passati?',
      login_cta: 'Accedi al tuo account',
      color: 'Colore',
      size: 'Taglia',
      size_sold_out: 'esaurita',
      you_had: 'la tua',
      pick_color: 'Scegli il colore',
      pick_size: 'Scegli la taglia',
      other_product: 'Cambia con un altro prodotto',
      cat_title: 'Scegli una categoria',
      prod_title: 'Scegli il prodotto',
      search_ph: 'Cerca un prodotto',
      no_results: 'Nessun prodotto trovato.',
      loading: 'Caricamento...',
      close: 'Chiudi',
      choose: 'Scegli questo articolo',
      diff_pay: 'Differenza da pagare',
      diff_refund: 'Ti rimborseremo la differenza',
      diff_none: 'Nessuna differenza di prezzo',
      diff_note: 'Se c’è una differenza da pagare ti invieremo una email con la richiesta di pagamento.',
      bundle_warn: 'Attenzione: l’articolo che rendi era in un’offerta (es. bundle). Scegliendo un prodotto diverso l’offerta decade: eventuali codici sconto restano validi, ma lo sconto dell’offerta non si applica al nuovo articolo.',
      offer_title: 'Preferisci un cambio? È gratuito',
      offer_body: 'Stai per chiedere un rimborso. Se il problema è la taglia, il colore o il modello, il cambio è gratuito: appena riceviamo il reso ti spediamo il nuovo articolo senza costi aggiuntivi.',
      offer_switch: 'Scelgo un cambio',
      offer_keep: 'Continua con il rimborso',
      active_case_1: 'Hai già una richiesta aperta per questo ordine:',
      active_case_2: 'Vuoi modificarla — per esempio trasformare il rimborso in un cambio gratuito? Annullala e rifai la richiesta qui sotto.',
      active_case_btn: 'Annulla la richiesta',
      active_case_btn2: 'Sicuro? Clicca di nuovo per annullare',
      active_case_done: 'Richiesta annullata: ora puoi farne una nuova.',
      active_case_locked: 'Questa richiesta è già in lavorazione: per modificarla scrivi a sales@stelviocollection.com citando il numero di pratica.',
      change_choice: 'Cambia scelta',
      keep: 'Tengo l’articolo',
      refund: 'Rimborso',
      exchange: 'Cambio taglia/colore',
      qty: 'Quantità',
      exchange_to: 'Cambia con',
      reason: 'Motivo',
      reason_ph: 'Seleziona un motivo',
      r_SIZE_TOO_SMALL: 'Troppo piccolo',
      r_SIZE_TOO_LARGE: 'Troppo grande',
      r_FIT: 'Vestibilità non adatta',
      r_COLOR: 'Colore diverso dal previsto',
      r_STYLE: 'Design / stile non adatto',
      r_DEFECTIVE: 'Difettoso o danneggiato',
      r_NOT_AS_DESCRIBED: 'Non come descritto',
      r_WRONG_ITEM: 'Articolo sbagliato ricevuto',
      r_OTHER: 'Altro',
      photo_label: 'Foto del problema (consigliata)',
      photo_added: 'Foto allegata',
      photo_error: 'Immagine non valida o troppo grande',
      note_ph: 'Note per il nostro team (facoltativo)',
      already_returned: 'Già reso o in un’altra richiesta',
      continue_btn: 'Continua',
      need_selection: 'Seleziona almeno un articolo da rendere o cambiare.',
      need_reason: 'Indica il motivo per ogni articolo selezionato.',
      reason_note_opt: 'Vuoi dirci di più? (facoltativo)',
      reason_note_req: 'Raccontaci il motivo',
      reason_note_ph: 'Es. la zip si è bloccata dopo due uscite',
      reason_note_ph_req: 'Scrivi qui il motivo',
      need_reason_note: 'Hai scelto "Altro": scrivi due righe sul motivo. È quello che ci dice cosa migliorare.',
      back: 'Indietro',
      step3_title: 'Riepilogo della richiesta',
      sum_items: 'Valore articoli resi',
      sum_deduction: 'Detrazione spese di spedizione',
      sum_deduction_note: 'Il tuo ordine aveva la spedizione gratuita: poiché il valore dei capi che tieni scende sotto la soglia, i costi di spedizione standard vengono detratti dal rimborso.',
      sum_total: 'Totale rimborso previsto',
      sum_exchange: 'Ti spediremo in cambio, senza costi aggiuntivi:',
      ship_free: 'Prepariamo noi l’etichetta di reso prepagata e te la inviamo via email entro 24 ore lavorative (dal lunedì al venerdì). Nei periodi di maggiore affluenza possono servire fino a 48 ore. Tieni il pacco pronto e attendi la nostra email.',
      ship_paid: 'La spedizione di reso è a carico del cliente (consigliamo un servizio tracciato). Riceverai le istruzioni via email.',
      ship_swiss: 'Riceverai via email l’etichetta Swiss Post prepagata, già pronta da stampare, entro 24 ore lavorative (dal lunedì al venerdì). Nei periodi di maggiore affluenza possono servire fino a 48 ore.',
      order_hint: 'Trovi il numero d’ordine nell’email di conferma dell’acquisto.',
      back_shop: 'Torna al negozio',
      exchange_diff0: 'Cambio a costo zero',
      confirm: 'Conferma richiesta',
      oos: 'La variante scelta per il cambio non è più disponibile. Torna indietro e scegline un’altra.',
      done_title: 'Richiesta inviata',
      done_case: 'Il numero della tua pratica è',
      done_body: 'Ti abbiamo inviato una email di conferma con il riepilogo e i prossimi passi. Controlla anche la posta indesiderata.',
      done_help: 'Domande? Scrivi a sales@stelviocollection.com citando il numero di pratica.'
    },
    en: {
      title: 'Returns and exchanges',
      intro: 'Enter your order number and the email used for the purchase.',
      order_ph: 'Order number (e.g. 5126)',
      email_ph: 'Your email',
      find: 'Find your order',
      not_found: 'We could not find an order with these details. Check the number and email.',
      not_shipped: 'This order has not shipped yet: you can request a return after delivery.',
      order_cancelled: 'This order appears to be cancelled.',
      window_expired: 'More than 14 days have passed since delivery, so we cannot handle this request through the portal. Write to sales@stelviocollection.com with your order number and we will see what we can do together.',
      returns_disabled: 'The returns portal is temporarily unavailable. Please try again later.',
      generic_error: 'Something went wrong. Please try again shortly.',
      rate_limited: 'Too many requests. Please try again in a few minutes.',
      case_open: 'There is already an open request for this order',
      case_open_2: 'You will receive updates by email. For questions write to sales@stelviocollection.com.',
      step2_title: 'Order',
      step2_intro: 'Choose what you would like to do for each item.',
      deadline_note: 'You can request a return until',
      estimate_note: '(estimated delivery date)',
      order_of: 'Order of',
      ship_to: 'Shipped to',
      login_q: 'Want to check your past orders?',
      login_cta: 'Log in to your account',
      color: 'Colour',
      size: 'Size',
      size_sold_out: 'sold out',
      you_had: 'yours',
      pick_color: 'Choose the colour',
      pick_size: 'Choose the size',
      other_product: 'Exchange for a different product',
      cat_title: 'Choose a category',
      prod_title: 'Choose the product',
      search_ph: 'Search for a product',
      no_results: 'No products found.',
      loading: 'Loading...',
      close: 'Close',
      choose: 'Choose this item',
      diff_pay: 'Difference to pay',
      diff_refund: 'We will refund the difference',
      diff_none: 'No price difference',
      diff_note: 'If there is a difference to pay we will email you a payment request.',
      bundle_warn: 'Please note: the item you are returning was part of an offer (e.g. a bundle). Exchanging it for a different product ends that offer: any discount codes still apply, but the offer discount does not carry over to the new item.',
      offer_title: 'Would you rather exchange? It’s free',
      offer_body: 'You are about to request a refund. If the issue is the size, colour or model, exchanges are free: as soon as we receive your return we ship the new item at no extra cost.',
      offer_switch: 'I’ll choose an exchange',
      offer_keep: 'Continue with the refund',
      active_case_1: 'You already have an open request for this order:',
      active_case_2: 'Want to change it — for example turn the refund into a free exchange? Cancel it and submit a new request below.',
      active_case_btn: 'Cancel this request',
      active_case_btn2: 'Sure? Click again to cancel',
      active_case_done: 'Request cancelled: you can now submit a new one.',
      active_case_locked: 'This request is already being processed: to change it, write to sales@stelviocollection.com quoting your case number.',
      change_choice: 'Change selection',
      keep: 'Keep this item',
      refund: 'Refund',
      exchange: 'Exchange size/colour',
      qty: 'Quantity',
      exchange_to: 'Exchange for',
      reason: 'Reason',
      reason_ph: 'Select a reason',
      r_SIZE_TOO_SMALL: 'Too small',
      r_SIZE_TOO_LARGE: 'Too big',
      r_FIT: 'Fit not right',
      r_COLOR: 'Colour not as expected',
      r_STYLE: 'Design / not my style',
      r_DEFECTIVE: 'Damaged or defective',
      r_NOT_AS_DESCRIBED: 'Not as described',
      r_WRONG_ITEM: 'Received the wrong item',
      r_OTHER: 'Other',
      photo_label: 'Photo of the issue (recommended)',
      photo_added: 'Photo attached',
      photo_error: 'Invalid or too large image',
      note_ph: 'Notes for our team (optional)',
      already_returned: 'Already returned or in another request',
      continue_btn: 'Continue',
      need_selection: 'Select at least one item to return or exchange.',
      need_reason: 'Please choose a reason for each selected item.',
      reason_note_opt: 'Want to tell us more? (optional)',
      reason_note_req: 'Tell us the reason',
      reason_note_ph: 'E.g. the zip jammed after two rides',
      reason_note_ph_req: 'Write the reason here',
      need_reason_note: 'You chose "Other": please write a line about why. It is what tells us what to improve.',
      back: 'Back',
      step3_title: 'Request summary',
      sum_items: 'Value of returned items',
      sum_deduction: 'Shipping cost deduction',
      sum_deduction_note: 'Your order shipped for free: since the value of the items you keep falls below the free-shipping threshold, standard shipping costs are deducted from the refund.',
      sum_total: 'Expected refund total',
      sum_exchange: 'We will ship you in exchange, at no extra cost:',
      ship_free: 'We prepare your prepaid return label and email it to you within 24 working hours (Monday to Friday). During busier periods it can take up to 48 hours. Keep the parcel ready and wait for our email.',
      ship_paid: 'Return shipping is at the customer’s expense (we recommend a tracked service). Instructions will follow by email.',
      ship_swiss: 'You will receive your prepaid Swiss Post label by email, ready to print, within 24 working hours (Monday to Friday). During busier periods it can take up to 48 hours.',
      order_hint: 'You can find your order number in your purchase confirmation email.',
      back_shop: 'Back to the shop',
      exchange_diff0: 'Free exchange',
      confirm: 'Confirm request',
      oos: 'The variant chosen for the exchange is no longer available. Go back and pick another one.',
      done_title: 'Request sent',
      done_case: 'Your case number is',
      done_body: 'We have sent you a confirmation email with the summary and next steps. Please also check your spam folder.',
      done_help: 'Questions? Write to sales@stelviocollection.com quoting your case number.'
    },
    de: {
      title: 'Rücksendungen und Umtausch',
      intro: 'Gib deine Bestellnummer und die beim Kauf verwendete E-Mail ein.',
      order_ph: 'Bestellnummer (z. B. 5126)',
      email_ph: 'Deine E-Mail',
      find: 'Bestellung finden',
      not_found: 'Wir konnten keine Bestellung mit diesen Daten finden. Prüfe Nummer und E-Mail.',
      not_shipped: 'Diese Bestellung wurde noch nicht versendet: eine Rücksendung ist nach der Zustellung möglich.',
      order_cancelled: 'Diese Bestellung wurde storniert.',
      window_expired: 'Seit der Zustellung sind mehr als 14 Tage vergangen, daher können wir die Anfrage nicht über das Portal bearbeiten. Schreib an sales@stelviocollection.com mit deiner Bestellnummer, dann schauen wir gemeinsam, was möglich ist.',
      returns_disabled: 'Das Rücksendeportal ist vorübergehend nicht verfügbar. Bitte versuche es später erneut.',
      generic_error: 'Etwas ist schiefgelaufen. Bitte versuche es gleich erneut.',
      rate_limited: 'Zu viele Anfragen. Bitte versuche es in ein paar Minuten erneut.',
      case_open: 'Für diese Bestellung existiert bereits eine offene Anfrage',
      case_open_2: 'Du erhältst Updates per E-Mail. Bei Fragen schreib an sales@stelviocollection.com.',
      step2_title: 'Bestellung',
      step2_intro: 'Wähle für jeden Artikel, was du tun möchtest.',
      deadline_note: 'Rücksendung möglich bis zum',
      estimate_note: '(geschätztes Lieferdatum)',
      order_of: 'Bestellung vom',
      ship_to: 'Geliefert an',
      login_q: 'Willst du deine früheren Bestellungen sehen?',
      login_cta: 'Zum Konto anmelden',
      color: 'Farbe',
      size: 'Größe',
      size_sold_out: 'ausverkauft',
      you_had: 'deine',
      pick_color: 'Farbe wählen',
      pick_size: 'Größe wählen',
      other_product: 'Gegen ein anderes Produkt tauschen',
      cat_title: 'Kategorie wählen',
      prod_title: 'Produkt wählen',
      search_ph: 'Produkt suchen',
      no_results: 'Keine Produkte gefunden.',
      loading: 'Lädt...',
      close: 'Schließen',
      choose: 'Diesen Artikel wählen',
      diff_pay: 'Differenz zu zahlen',
      diff_refund: 'Wir erstatten die Differenz',
      diff_none: 'Keine Preisdifferenz',
      diff_note: 'Bei einer Differenz senden wir dir eine E-Mail mit der Zahlungsaufforderung.',
      bundle_warn: 'Hinweis: der zurückgesendete Artikel war Teil eines Angebots (z. B. Bundle). Beim Tausch gegen ein anderes Produkt entfällt das Angebot: Rabattcodes bleiben gültig, der Angebotsrabatt gilt jedoch nicht für den neuen Artikel.',
      offer_title: 'Lieber umtauschen? Es ist kostenlos',
      offer_body: 'Du bist dabei, eine Rückerstattung anzufordern. Wenn es an Größe, Farbe oder Modell liegt: der Umtausch ist kostenlos. Sobald deine Rücksendung bei uns ankommt, senden wir dir den neuen Artikel ohne Zusatzkosten.',
      offer_switch: 'Ich wähle einen Umtausch',
      offer_keep: 'Weiter mit der Rückerstattung',
      active_case_1: 'Für diese Bestellung gibt es bereits eine offene Anfrage:',
      active_case_2: 'Möchtest du sie ändern — zum Beispiel die Rückerstattung in einen kostenlosen Umtausch verwandeln? Storniere sie und stelle unten eine neue Anfrage.',
      active_case_btn: 'Anfrage stornieren',
      active_case_btn2: 'Sicher? Nochmals klicken zum Stornieren',
      active_case_done: 'Anfrage storniert: du kannst jetzt eine neue stellen.',
      active_case_locked: 'Diese Anfrage wird bereits bearbeitet: für Änderungen schreib an sales@stelviocollection.com mit deiner Vorgangsnummer.',
      change_choice: 'Auswahl ändern',
      keep: 'Artikel behalten',
      refund: 'Rückerstattung',
      exchange: 'Größe/Farbe tauschen',
      qty: 'Menge',
      exchange_to: 'Tauschen gegen',
      reason: 'Grund',
      reason_ph: 'Grund auswählen',
      r_SIZE_TOO_SMALL: 'Zu klein',
      r_SIZE_TOO_LARGE: 'Zu groß',
      r_FIT: 'Passform nicht richtig',
      r_COLOR: 'Farbe anders als erwartet',
      r_STYLE: 'Design / nicht mein Stil',
      r_DEFECTIVE: 'Beschädigt oder defekt',
      r_NOT_AS_DESCRIBED: 'Nicht wie beschrieben',
      r_WRONG_ITEM: 'Falschen Artikel erhalten',
      r_OTHER: 'Sonstiges',
      photo_label: 'Foto des Problems (empfohlen)',
      photo_added: 'Foto angehängt',
      photo_error: 'Ungültiges oder zu großes Bild',
      note_ph: 'Hinweise für unser Team (optional)',
      already_returned: 'Bereits zurückgesendet oder in anderer Anfrage',
      continue_btn: 'Weiter',
      need_selection: 'Wähle mindestens einen Artikel zur Rücksendung oder zum Umtausch.',
      need_reason: 'Bitte gib für jeden gewählten Artikel einen Grund an.',
      reason_note_opt: 'Möchtest du uns mehr sagen? (optional)',
      reason_note_req: 'Nenne uns den Grund',
      reason_note_ph: 'Z. B. der Reissverschluss klemmte nach zwei Ausfahrten',
      reason_note_ph_req: 'Schreib den Grund hier',
      need_reason_note: 'Du hast "Sonstiges" gewählt: schreib uns bitte kurz warum. Genau das sagt uns, was wir verbessern müssen.',
      back: 'Zurück',
      step3_title: 'Zusammenfassung der Anfrage',
      sum_items: 'Wert der zurückgesendeten Artikel',
      sum_deduction: 'Abzug Versandkosten',
      sum_deduction_note: 'Deine Bestellung wurde kostenlos versendet: da der Wert der behaltenen Artikel unter die Gratisversand-Schwelle fällt, werden die Standard-Versandkosten von der Rückerstattung abgezogen.',
      sum_total: 'Voraussichtliche Rückerstattung',
      sum_exchange: 'Im Tausch senden wir dir ohne Zusatzkosten:',
      ship_free: 'Wir bereiten dein frankiertes Rücksendeetikett vor und senden es dir per E-Mail innerhalb von 24 Arbeitsstunden (Montag bis Freitag). In Zeiten mit hohem Aufkommen kann es bis zu 48 Stunden dauern. Halte das Paket bereit und warte auf unsere E-Mail.',
      ship_paid: 'Die Rücksendekosten trägt der Kunde (wir empfehlen Versand mit Tracking). Die Anleitung folgt per E-Mail.',
      ship_swiss: 'Du erhältst dein frankiertes Swiss Post Etikett per E-Mail, druckfertig, innerhalb von 24 Arbeitsstunden (Montag bis Freitag). In Zeiten mit hohem Aufkommen kann es bis zu 48 Stunden dauern.',
      order_hint: 'Die Bestellnummer findest du in der Bestellbestätigung per E-Mail.',
      back_shop: 'Zurück zum Shop',
      exchange_diff0: 'Umtausch ohne Aufpreis',
      confirm: 'Anfrage bestätigen',
      oos: 'Die gewählte Variante ist nicht mehr verfügbar. Geh zurück und wähle eine andere.',
      done_title: 'Anfrage gesendet',
      done_case: 'Deine Vorgangsnummer ist',
      done_body: 'Wir haben dir eine Bestätigungs-E-Mail mit der Übersicht und den nächsten Schritten gesendet. Prüfe auch deinen Spam-Ordner.',
      done_help: 'Fragen? Schreib an sales@stelviocollection.com und nenne deine Vorgangsnummer.'
    }
  };
})();
